import { type LocaleString, supportedLocales } from "@sa-nu/shared-types";

import {
  domainNamespaceList,
  webappNamespaces,
} from "../__generated__/i18n/namespaces.generated";

export const defaultNS = "common" as const;
export const fallbackLng = "ja" as const satisfies LocaleString;
export const supportedLngs = supportedLocales;
export type { LocaleString };

// URL に現れる locale (fallback の "ja" は prefix なしのため除外)
const URL_LOCALE_ALTERNATION = supportedLngs
  .filter((l) => l !== fallbackLng)
  .map((l) => l.toLowerCase())
  .join("|");

// `/en` または `/zh-cn` の URL prefix。`/` or 文字列末尾が後続する箇所のみマッチ。
// 例: `/en`, `/en/`, `/en/foo` にマッチ。`/enfoo` にはマッチしない。
// 用途: 単純な存在判定 / locale prefix の strip。
// 大文字 (`/EN`, `/Zh-Cn` 等) は対応外 URL として match させず default (ja) に倒す。
export const LOCALE_PREFIX_RE = new RegExp(
  `^\\/(${URL_LOCALE_ALTERNATION})(\\/|$)`,
);

// `/en` または `/zh-cn` の URL prefix と、後続のパス部分を捕捉。
// 例: `/en/foo` にマッチし、group 1 = "en"、group 2 = "/foo"。
// 用途: locale プレフィックスを取り除いた残りのパスを取得 / 言語切替リンク生成。
// 大文字 (`/EN`, `/Zh-Cn` 等) は対応外 URL として match させず default (ja) に倒す。
export const LOCALE_PREFIX_WITH_PATH_RE = new RegExp(
  `^\\/(${URL_LOCALE_ALTERNATION})(\\/.*|$)`,
);

export const i18nNamespaces = [
  ...webappNamespaces,
  ...domainNamespaceList,
] as const;
export type I18nNamespace = (typeof i18nNamespaces)[number];

export const domainNamespaces: readonly I18nNamespace[] = domainNamespaceList;

export function parseLocale(urlSegment: string): LocaleString {
  switch (urlSegment.toLowerCase()) {
    case "en":
      return "en";
    case "zh-cn":
      return "zh-CN";
    case "zh-tw":
      return "zh-TW";
    default:
      return "ja";
  }
}

export const i18nConfig = {
  defaultNS,
  fallbackLng,
  fallbackNS: defaultNS,
  ns: [...i18nNamespaces],
  supportedLngs: [...supportedLngs],
} as const;
